import ShowLoader from '@/components/Loader';
import ScrollToTop from '@/components/ScrollToTop';
import { fetchRFQCustomerInfo } from '@/store/slices/rfqSlice';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const OrderCustomerInfo = ({ rfq_id }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('order');

  useEffect(() => {
    dispatch(fetchRFQCustomerInfo(rfq_id));
  }, []);
  const { customersInfo, loading } = useSelector((state) => state.rfq);

  return (
    <div className='px-4 md:px-6'>
      {loading && <ShowLoader />}
      <ScrollToTop />
      <div className="bg-white shadow rounded-lg p-8">
        <div className="flex items-center justify-between mb-6 border-b border-gray-300 pb-4">
          <h2 className="text-xl font-semibold text-gray-800">{customersInfo?.customer?.company_name}</h2>

        </div>

        <div className="border-b border-gray-200 pb-6 mb-6">
          <div className="flex flex-wrap gap-3 mb-6 whitespace-nowrap">
            <div className='basis-1/3 max-w-[200px]'>
              <p className="text-sm font-medium text-gray-500">{t('contact_person_label')}</p>
              <p className="mt-1 text-base text-gray-900">{customersInfo?.customer?.first_name} {customersInfo?.customer?.last_name}</p>
            </div>
            <div className='basis-1/3 max-w-[200px]'>
              <p className="text-sm font-medium text-gray-500">{t('phone_number_label')}</p>
              <p className="mt-1 text-base text-gray-900">{customersInfo?.customer?.country_code} {customersInfo?.customer?.mobile_number}</p>
            </div>
            <div className='basis-1/3 max-w-[200px]'>
              <p className="text-sm font-medium text-gray-500">{t('email_id_label')}</p>
              <p className="mt-1 text-base text-gray-900">{customersInfo?.customer?.email} </p>
            </div>
          </div>

          <div className="flex flex-wrap gap-3 mb-6 whitespace-nowrap">
            <div className='basis-1/3 max-w-[200px]'>
              <p className="text-sm font-medium text-gray-500">{t('alternate_phone_number_label')}</p>
              <p className="mt-1 text-base text-gray-900">{customersInfo?.customer?.alternate_country_code} {customersInfo?.customer?.alternate_number ?? 'N/A'}</p>
            </div>
            <div className='basis-1/3 max-w-[200px]'>
              <p className="text-sm font-medium text-gray-500">{t('alternate_email_id_label')}</p>
              <p className="mt-1 text-base text-gray-900">{customersInfo?.customer?.email}</p>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <p className="text-sm font-medium text-gray-500">{t('company_address_label')}</p>
          <p className="mt-1 text-base text-gray-900"> {customersInfo?.customer?.permanent_address ?? 'N/A'}</p>
        </div>

        <div>
          <p className="text-sm font-medium text-gray-500">{t('delivery_address_label')}</p>
          <p className="mt-1 text-base text-gray-900">{customersInfo?.customer?.permanent_address ?? 'N/A'}</p>
        </div>
      </div>

    </div>
  );
};

export default OrderCustomerInfo;